<template>
  <div class="header-menu">
    <el-row class="header-menu__wrapper">
      <el-col :span="20">
        <div class="header-nav">
          <ul class="clearfix">
            <li
              v-for="(item, index) of unionHead.menuItems"
              :key="index"
              class="header-nav__item"
              :class="{
                'header-nav__item_active': item.name === '健康生活'
              }"
            >
              <a :href="item.url" target="_self">
                <span class="header-nav__item_ch">{{ item.name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="header-search">
          <div class="header-search__inner">
            <!-- 英文 -->
            <input
              v-if="CookiesOne==='en-US'"
              type="text"
              placeholder="Search"
              class="header-search__input"
              @keyup.enter="onSubmit"
            />
            <!-- 中文 -->
            <input
              v-if="CookiesOne!=='en-US'"
              type="text"
              placeholder="搜索"
              class="header-search__input"
              @keyup.enter="onSubmit"
            />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { gioClickHandle as gioHandle, getQueryString } from "../../utils";
export default {
  props: {
    unionHead: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      CookiesOne:Cookies.get('df_lang'),
    }
  },
  methods: {
    async onSubmit(ev) {
      const val = ev.target.value.trim();
      const city = (Cookies.get('address') &&
          JSON.parse(Cookies.get('address') || '{}').cityId) ||
        '145';
      const res = await this.apis.headerApi.getSearchUrl({
        keyword: val,
        city,
      });
      gioHandle("DF_elementClick", {
        df_channle: "",
        df_pagename: "搜索页",
        df_modulename: "搜索历史",
        df_elementname: "搜索历史词",
        df_searchKeyword: ev.target.innerText,
        df_pageType: res && res.body && res.body.linkUrl ? "词链" : ""
      });
      if (res && res.body && res.body.linkUrl) {
        window.location.href = res.body.linkUrl;
      } else {
        // this.$emit("onSubmit", ev, ev.target.innerText);
        const origin = window.location.origin;
        const city = getQueryString('city');
        window.open(`${origin}/health/search?keywords=${val}&city=${city}`);
      }
      // const val = ev.target.value.trim();
      // const origin = window.location.origin;
      // const city = this.publicMethod.getQueryString('city');

      // window.location.href = `${origin}/health/search?keywords=${val}&city=${city}`;
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  &-menu {
    background-color: #1a4a9e;
    height: 48px;
    &__wrapper {
      .wrapper();
    }
  }
  &-nav {
    &__item {
      float: left;
      font-size: 14px;
      line-height: 48px;
      padding-left: 20px;
      padding-right: 20px;
      > a {
        display: block;
        color: #fff;
      }
      &:hover {
        transform: skewX(160deg);
        background-color: #e5152e;
        > a {
          transform: skewX(-160deg);
        }
      }
      &_active {
        transform: skewX(160deg);
        background-color: #e5152e;
        > a {
          transform: skewX(-160deg);
        }
      }
    }
  }
  &-search {
    display: table;
    width: 100%;
    height: 34px;
    padding-left: 15px;
    padding-right: 15px;
    background-color: #fff;
    border-radius: 20px;
    margin-top: 7px;
    &__inner {
      display: table-cell;
      vertical-align: middle;
    }
    &__input {
      box-sizing: border-box;
      width: 100%;
      height: 24px;
      padding-top: 2px;
      padding-bottom: 2px;
      font-size: 14px;
      background-color: #fff;
      background-image: none;
      border: none;
      outline: none;
      &::-webkit-input-placeholder {
        color: #999;
      }
      &::-moz-input-placeholder {
        color: #999;
      }
      &:-ms-input-placeholder {
        color: #999;
      }
    }
  }
}
</style>
